import React from "react";
import ContentPage from "../components/ContentPage";

export default function SolutionPage() {
  return (
    <ContentPage title="Our Solution">
      <div className="prose prose-invert max-w-none" data-testid="solution-content">
        <p className="text-[#E8E4DC] text-lg mb-8">
          Top Screen&#8482; is a universal, customizable overlay that keeps your most important content 
          visible at all times — on every device, in every situation.
        </p>

        <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">How It Works</h2>
        <div className="space-y-6 mb-10">
          {[
            { n: "1", t: "Choose Your Content", d: "Select any tab, website, video, app, or document to display in your Top Screen™ window. Unlike native PiP, we're not limited to video elements — anything on your screen can become an overlay.", color: "#A3E635" },
            { n: "2", t: "Customize Your Frame", d: "Pick from 5 frame styles: None (borderless), Classic (solid border), RGB Backlight (animated rainbow), Neon Glow (pulsing neon), or Shadow (elevated depth). Set any color, adjust border width from 1-12px, and control opacity.", color: "#60a5fa" },
            { n: "3", t: "Position & Size", d: "Drag your Top Screen™ window anywhere. Choose from Small (320×240), Medium (480×360), Large (640×480), or XL (960×720). Snap to corners with one click — top-left, top-right, bottom-left, or bottom-right.", color: "#f472b6" },
            { n: "4", t: "Enable Always On Top", d: "Your content stays visible over everything — other apps, full-screen mode, even your lock screen (desktop). Theatre Mode dims everything behind it for immersive viewing.", color: "#facc15" },
            { n: "5", t: "Set & Forget", d: "Configure timers and alarms to automatically pop up content at specific times. Schedule your morning stock dashboard, your afternoon standup, or your evening news — it just appears when you need it.", color: "#c084fc" },
          ].map(s => (
            <div key={s.n} className="flex items-start gap-5">
              <div className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-black shrink-0" style={{ background: s.color }}>{s.n}</div>
              <div>
                <h3 className="text-white font-semibold text-lg mb-1">{s.t}</h3>
                <p className="text-[#E8E4DC]">{s.d}</p>
              </div>
            </div>
          ))}
        </div>

        <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">Core Features</h2>
        <div className="grid md:grid-cols-2 gap-4 mb-8">
          {[
            { icon: "pin", title: "Always On Top (AOT)", desc: "Stays above all windows, even full-screen apps and lock screens." },
            { icon: "frame", title: "Custom Frames", desc: "5 styles: None, Classic, RGB, Neon, Shadow. Any color, 1-12px width." },
            { icon: "theatre", title: "Theatre Mode", desc: "Dims everything behind your overlay for distraction-free viewing." },
            { icon: "multi", title: "Multiple Instances", desc: "Run several Top Screen™ windows simultaneously. Monitor everything." },
            { icon: "audio", title: "Audio Override", desc: "Independent volume and mute controls. Never miss audio from your overlay." },
            { icon: "timer", title: "Timer & Alarms", desc: "Schedule content pop-ups. Auto-show your meeting 5 min before it starts." },
            { icon: "team", title: "Team Collaboration", desc: "Share screens across your team. Perfect for trading floors and NOCs." },
            { icon: "cross", title: "Cross-Platform", desc: "Chrome/Edge Extension, Windows Desktop, iOS, Android. One license, all devices." },
          ].map((f, i) => (
            <div key={i} className="card-glass p-4 flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-[#A3E635]/10 flex items-center justify-center shrink-0 mt-1">
                <svg className="w-4 h-4 text-[#A3E635]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path d="M5 13l4 4L19 7" /></svg>
              </div>
              <div>
                <h4 className="text-white font-semibold text-sm">{f.title}</h4>
                <p className="text-[#E8E4DC] text-xs">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">Pricing That Makes Sense</h2>
        <div className="card-glass p-6 text-center mb-6">
          <p className="text-[#E8E4DC] mb-2">Early Adopters' Special — Limited to first 10,000 users</p>
          <div className="text-5xl font-bold text-white mb-2">$18.99</div>
          <p className="text-[#A3E635] font-semibold">One-time payment. Lifetime access. All devices.</p>
          <p className="text-[#E8E4DC] text-sm mt-2">Starts with a 72-hour full-feature trial. No credit card required.</p>
        </div>
      </div>
    </ContentPage>
  );
}
